import { render, staticRenderFns } from "./SolicitudLlamadasIndex.vue?vue&type=template&id=2f9d2bd3&scoped=true&"
import script from "./SolicitudLlamadasIndex.vue?vue&type=script&lang=js&"
export * from "./SolicitudLlamadasIndex.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudLlamadasIndex.vue?vue&type=style&index=0&id=2f9d2bd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9d2bd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
